/* cl-kcart.js — gaveta do carrinho (replica do app Kaching Cart do concorrente), vanilla.
   Abre com o evento cl:cart:open (cl-ui.js dispara no icone do header e depois de todo ATC, com o HTML da secao
   ja renderizado na resposta do /cart/add.js), fecha no X/overlay/Esc/"Provalo senza rischi", +/-/digitado e
   lixeira por /cart/change.js, upsell com seletor de opcoes por /cart/add.js, timer de 10 min, checkout.
   Re-render pela Section Rendering API (?sections=cl-cart-drawer). */
(function () {
  'use strict';
  var SECTION = 'cl-cart-drawer';
  var TIMER_S = 600;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function host() { return document.querySelector('[data-cl-cart-drawer]'); }
  function wrap() { return document.getElementById('cl-cart-drawer'); }
  function panel() { var w = wrap(); return w && w.querySelector('.kaching-cart'); }

  /* estado da gaveta numa variavel: o apply() troca o painel inteiro (innerHTML) e o `active` posto 2 frames depois do open()
     caia no painel ANTIGO -> na loja real (resposta do add COM a secao) a gaveta atualizava mas nao abria (retrabalho 10-30) */
  var wantOpen = false;
  function show() {
    var w = wrap(), p = panel(); if (!w || !p) return;
    w.classList.add('cl-open'); w.setAttribute('aria-hidden', 'false');
    p.setAttribute('data-open', 'true');
    requestAnimationFrame(function () { requestAnimationFrame(function () { var q = panel(); if (wantOpen && q) q.classList.add('active'); }); });
  }
  function open() {
    wantOpen = true;
    show();
    document.documentElement.classList.add('cl-cart-open');
    var p = panel(), inner = p && p.querySelector('.kaching-cart__inner'); if (inner) try { inner.focus({ preventScroll: true }); } catch (e) {}
    tick();
  }
  function close() {
    wantOpen = false;
    var w = wrap(), p = panel(); if (!w || !p) return;
    p.classList.remove('active'); p.removeAttribute('data-open');
    document.documentElement.classList.remove('cl-cart-open');
    setTimeout(function () { if (!wantOpen) { w.classList.remove('cl-open'); w.setAttribute('aria-hidden', 'true'); } }, 350);
  }
  function isOpen() { return wantOpen; }

  /* contador do <cart-icon> do Horizon: o Liquid poe .hidden no numero quando a pagina abre com o carrinho vazio e o
     cart-icon.js reconcilia pelo sessionStorage 'cart-count' (retrabalho 10-30: so o F5 mostrava o numero) */
  function bubble(n) {
    document.querySelectorAll('.cart-bubble__text-count, [data-cl-cart-count]').forEach(function (el) {
      el.textContent = n < 100 ? n : ''; el.classList.toggle('hidden', n === 0);
    });
    document.querySelectorAll('.cart-bubble').forEach(function (b) { b.classList.toggle('visually-hidden', n === 0); });
    document.querySelectorAll('cart-icon, .header-actions__cart-icon').forEach(function (c) { c.classList.toggle('header-actions__cart-icon--has-cart', n > 0); });
    try { sessionStorage.setItem('cart-count', JSON.stringify({ value: String(n < 100 ? n : ''), timestamp: Date.now() })); } catch (e) {}
  }

  /* troca o miolo pelo HTML da secao; devolve false se veio o carrinho vazio */
  function apply(html) {
    if (!html) return true;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('cl-cart-drawer'), cur = wrap();
    if (!fresh || !cur) return true;
    var n = parseInt(fresh.getAttribute('data-count'), 10) || 0;
    cur.innerHTML = fresh.innerHTML;
    cur.setAttribute('data-count', n);
    if (wantOpen) { var p = panel(); if (p) { p.classList.add('active'); p.setAttribute('data-open', 'true'); } }
    bubble(n); tick();
    document.dispatchEvent(new CustomEvent('cl:cart:rendered'));
    return n > 0;
  }
  /* GET da secao logo depois de um POST pode vir com o carrinho ANTERIOR (consistencia eventual): a referencia e o
     /cart.js; a secao so e aplicada quando o data-count dela bate com ele (ate 8 tentativas). */
  function render(added, k, want) {
    k = k || 0;
    var count = want != null ? Promise.resolve(want) : fetch('/cart.js?_=' + Date.now(), { headers: { Accept: 'application/json' }, cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) { return r.json(); }).then(function (c) { return c.item_count; }).catch(function () { return null; });
    return count.then(function (n) {
      /* NUNCA a rota da pagina: em /products/x um GET com Accept json devolve o JSON do PRODUTO e ignora ?sections=
         (a gaveta nunca re-renderizava numa PDP sem a resposta de um POST). A raiz da loja devolve a secao. */
      return fetch(ROOT + '?sections=' + SECTION + '&_=' + Date.now(), { cache: 'no-store', credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var html = j && j[SECTION];
          var got = html ? parseInt((html.match(/data-count="(\d+)"/) || [])[1], 10) : null;
          if (n != null && got !== n && k < 8) {
            return new Promise(function (res) { setTimeout(res, 300 + k * 250); }).then(function () { return render(added, k + 1, n); });
          }
          apply(html);
          if (n != null) bubble(n);
        });
    }).catch(function () {});
  }
  function busy(on) { var p = panel(); if (p) p.classList.toggle('is-loading', !!on); }
  /* retrabalho 10-30: o embed Kaching intercepta todo cart/add sem ?kaching_bundles=true (na PDP com deal ele MESCLA o
     lote selecionado no add do upsell). A secao que vem NA resposta do POST e a fonte certa; sem ela, render() confere com o /cart.js */
  function post(url, body, added) {
    busy(true);
    if (url === '/cart/add.js') url = '/cart/add.js?kaching_bundles=true';
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(Object.assign({ sections: SECTION, sections_url: location.pathname }, body)) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) {
        var want = typeof j.item_count === 'number' ? j.item_count : null;
        if (j.sections && j.sections[SECTION]) { apply(j.sections[SECTION]); if (want != null) bubble(want); }
        else return render(added, 0, want);
      })
      .catch(function (err) {
        return render(false).then(function () {
          var box = document.getElementById('CartDrawer-CartErrors');
          if (box) box.textContent = (err && (err.description || err.message)) || 'Errore';
        });
      })
      .then(function () { busy(false); });
  }
  window.clCart = { open: open, close: close, render: render, add: function (items) { open(); return post('/cart/add.js', { items: items }, true); } };

  /* cl-ui.js: icone do carrinho e ATC -> cl:cart:open (detail.html = secao renderizada na resposta do add) */
  document.addEventListener('cl:cart:open', function (e) {
    var d = e.detail || {};
    open();
    if (d.html) { if (!apply(d.html)) render(true); }
    else render(!!d.added);
  });

  /* ---------------- timer "Il carrello scadra tra" (10 min a partir da 1a abertura da sessao) */
  function left() {
    var s = 0;
    try { s = parseInt(sessionStorage.getItem('cl-kcart-t0'), 10) || 0; } catch (e) {}
    if (!s) { s = Date.now(); try { sessionStorage.setItem('cl-kcart-t0', String(s)); } catch (e) {} }
    var l = TIMER_S - Math.floor((Date.now() - s) / 1000);
    if (l <= 0) { try { sessionStorage.setItem('cl-kcart-t0', String(Date.now())); } catch (e) {} l = TIMER_S; }
    return l;
  }
  function tick() {
    var els = document.querySelectorAll('#cl-cart-drawer [data-clk-timer]'); if (!els.length) return;
    var l = left(), t = ('0' + Math.floor(l / 60)).slice(-2) + ':' + ('0' + (l % 60)).slice(-2);
    els.forEach(function (el) { el.textContent = t; });
  }
  setInterval(function () { if (isOpen()) tick(); }, 1000);

  /* ---------------- upsell: variante pelas opcoes escolhidas */
  function pick(card) {
    var j = card.querySelector('script[data-clk-variants]'); if (!j) return null;
    var vs; try { vs = JSON.parse(j.textContent); } catch (e) { return null; }
    var want = []; card.querySelectorAll('select[data-clk-opt]').forEach(function (s) { want[+s.getAttribute('data-clk-opt')] = s.value; });
    for (var i = 0; i < vs.length; i++) {
      var ok = true; for (var k = 0; k < want.length; k++) if (want[k] != null && vs[i].options[k] !== want[k]) { ok = false; break; }
      if (ok) return vs[i];
    }
    return null;
  }
  function money(c) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'it', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(c / 100); }
    catch (e) { return (c / 100).toFixed(2); }
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.closest || !t.closest('#cl-cart-drawer')) return;
    if (t.matches('select[data-clk-opt]')) {
      var card = t.closest('[data-clk-upsell]'), v = card && pick(card); if (!v) return;
      card.setAttribute('data-variant-id', v.id);
      var pr = card.querySelector('[data-clk-price]'); if (pr) pr.textContent = '⁨' + money(v.price) + '⁩';
      var b = card.querySelector('[data-clk-upsell-add]'); if (b) b.disabled = !v.available;
      return;
    }
    if (t.matches('[data-cl-qty-input]')) {
      post('/cart/change.js', { id: t.getAttribute('data-key'), quantity: Math.max(0, parseInt(t.value, 10) || 0) });
    }
  });

  document.addEventListener('click', function (e) {
    var t = e.target; if (!t.closest) return;
    var d = wrap(); if (!d || !d.contains(t)) return;
    if (t.closest('[data-cl-cd-close]')) { e.preventDefault(); close(); return; }
    var q = t.closest('[data-cl-qty]');
    if (q) { e.preventDefault(); post('/cart/change.js', { id: q.getAttribute('data-key'), quantity: Math.max(0, parseInt(q.getAttribute('data-cl-qty'), 10) || 0) }); return; }
    var add = t.closest('[data-clk-upsell-add]');
    if (add) {
      e.preventDefault();
      var card = add.closest('[data-clk-upsell]'), id = card && parseInt(card.getAttribute('data-variant-id'), 10);
      if (id) post('/cart/add.js', { items: [{ id: id, quantity: 1 }] }, true);
      return;
    }
    var nav = t.closest('[data-clk-car]');
    if (nav) {
      e.preventDefault();
      var list = nav.closest('.kaching-cart__carousel').querySelector('[data-clk-car-list]'); if (!list) return;
      list.scrollBy({ left: (parseInt(nav.getAttribute('data-clk-car'), 10) || 1) * list.clientWidth, behavior: 'smooth' });
      return;
    }
    if (t.closest('[data-clk-checkout]')) {
      e.preventDefault();
      var sp = d.querySelector('.kaching-cart__checkout-button-spinner'); if (sp) sp.style.display = '';
      window.location.href = '/checkout';
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) close(); });
  /* pagina restaurada do cache de navegacao (botao Voltar): a gaveta e a do carregamento antigo -> ressincroniza */
  window.addEventListener('pageshow', function (e) { if (e.persisted) render(false); });
  /* Voltar sem bfcache: o navegador reusa o HTML do cache HTTP (gaveta antiga) */
  try {
    var nav = performance.getEntriesByType('navigation')[0];
    if (nav && nav.type === 'back_forward') render(false);
  } catch (e) {}
})();
